import { LoginModelReqTypes, LoginModelResTypes } from "src/models/LoginModel";
import { PublicApi } from "./BaseApi";

const LoginApi = PublicApi.injectEndpoints({
  endpoints: (builder) => ({
    Login: builder.mutation<LoginModelResTypes, LoginModelReqTypes>({
      query: ({ userName, password }) => ({
        url: `/Dashboard/GetToken`,
        method: "POST",
        body: {
          data: {
            username: userName,
            password,
          },
        },
      }),
      transformResponse: (response: LoginModelResTypes) => response,
    }),
  }),
});

export const { useLoginMutation } = LoginApi;
export default LoginApi;
